<template>
  <div
    class="ads-player"
    :class="{ 'ads-player--active': adsManager.isAdPlaying.value }"
  >
    <video
      ref="adVideoElement"
      class="ads-player__video"
      :controls="false"
      :autoplay="false"
      playsinline
      preload="auto"
      :aria-label="t('player.ads.advertisement')"
    />
  </div>
</template>

<script setup lang="ts">
  import { ref, onMounted, onBeforeUnmount } from 'vue'
  import type { UseAdsManagerReturn } from '../../composables/useAdsManager'
  import { useVideoI18n } from '../../i18n'

  const props = defineProps<{
    adsManager: UseAdsManagerReturn
  }>()

  const { t } = useVideoI18n()
  const adVideoElement = ref<HTMLVideoElement | null>(null)

  // The `<video>` is unconditional, so the element is the same from mount to unmount.
  onMounted(() => {
    props.adsManager.setAdVideo(adVideoElement.value)
  })

  // The player unmounts this layer when the ads configuration goes away, and when it is torn down
  // itself; either way the manager lets go of the element and stops what it was playing.
  onBeforeUnmount(() => {
    if (props.adsManager.adVideoRef.value === adVideoElement.value) {
      props.adsManager.setAdVideo(null)
    }
  })
</script>

<style scoped lang="scss">
  .ads-player {
    position: absolute;
    inset: 0;
    z-index: 5;
    background: #000;
    pointer-events: none;

    &--active {
      pointer-events: auto;
    }

    &__video {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
</style>
